/* Keep the PDP headline price aligned with the lowest total price rendered by
   the active Kaching Bundles experiment. Kaching owns offer calculation and
   Markets formatting; this bridge only reads the visible offer output. */
(function () {
  'use strict';

  if (window.__grKachingLowestPriceSync) return;
  window.__grKachingLowestPriceSync = true;

  const BAR_SELECTOR = 'kaching-bundles-block .kaching-bundles__bar';
  const BOX_SELECTOR = '.gr-buy__price';
  let frame = 0;

  function isVisible(element) {
    if (!element || element.getClientRects().length === 0) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function moneyParts() {
    const locale = document.documentElement.lang || GR.locale || 'en';
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';

    try {
      const parts = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).formatToParts(12345.6);

      return {
        group: (parts.find(function (part) { return part.type === 'group'; }) || {}).value || ',',
        decimal: (parts.find(function (part) { return part.type === 'decimal'; }) || {}).value || '.'
      };
    } catch (error) {
      return { group: ',', decimal: '.' };
    }
  }

  function parseMoney(text) {
    if (!text) return null;

    const parts = moneyParts();
    let normalized = String(text).replace(/[  \s]/g, '');

    if (parts.group) normalized = normalized.split(parts.group).join('');
    if (parts.decimal && parts.decimal !== '.') {
      const pieces = normalized.split(parts.decimal);
      const decimals = pieces.pop();
      normalized = pieces.join('') + '.' + decimals;
    }

    normalized = normalized.replace(/[^0-9.-]/g, '');
    const amount = Number(normalized);
    return Number.isFinite(amount) ? Math.round(amount * 100) : null;
  }

  function readOffer(bar) {
    const price = parseMoney(bar.querySelector('.kaching-bundles__bar-price')?.textContent);
    if (price === null || price <= 0) return null;

    const compare = parseMoney(bar.querySelector('.kaching-bundles__bar-full-price')?.textContent);
    return {
      price: price,
      compare: compare !== null && compare > price ? compare : 0
    };
  }

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function paintLowestPrice() {
    const box = document.querySelector(BOX_SELECTOR);
    if (!box) return;

    const offers = Array.from(document.querySelectorAll(BAR_SELECTOR))
      .filter(isVisible)
      .map(readOffer)
      .filter(Boolean);

    if (!offers.length) return;

    const lowest = offers.reduce(function (best, offer) {
      return offer.price < best.price ? offer : best;
    });

    const currentPrices = Array.from(document.querySelectorAll('[data-gr-price="effective"]'));
    const comparePrices = [
      box.querySelector('.gr-buy__price-was'),
      document.querySelector('.gr-sticky__was')
    ].filter(Boolean);
    const saving = box.querySelector('[data-gr-price="saving"]');
    const savingBadge = saving && saving.closest('.gr-buy__price-save');
    const currentText = GR.money(lowest.price);
    const compareText = lowest.compare > 0 ? GR.money(lowest.compare) : '';

    currentPrices.forEach(function (element) {
      setText(element, currentText);
    });

    document.querySelectorAll('[data-add-to-cart][data-label-template]').forEach(function (button) {
      const template = button.getAttribute('data-label-template') || '';
      if (template.indexOf('[price]') === -1) return;
      setText(button.querySelector('[data-add-to-cart-label]'), template.replace('[price]', currentText));
    });

    comparePrices.forEach(function (element) {
      element.hidden = lowest.compare <= 0;
      setText(element, compareText);
    });

    /* The badge quotes the saving as a percentage of the offer's own full price.
       The trailing % sign is part of the localised string around the span, so
       only the number is written here. */
    const savingAmount = lowest.compare > lowest.price ? lowest.compare - lowest.price : 0;
    const savingPercent = savingAmount > 0 ? Math.round((savingAmount / lowest.compare) * 100) : 0;
    if (saving) {
      saving.hidden = savingPercent <= 0;
      setText(saving, savingPercent > 0 ? String(savingPercent) : '');
    }
    if (savingBadge) savingBadge.hidden = savingPercent <= 0;

    box.setAttribute('data-kaching-lowest-price', String(lowest.price));
  }

  function schedulePaint() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = 0;
      paintLowestPrice();
    });
  }

  function start() {
    schedulePaint();

    const observer = new MutationObserver(schedulePaint);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });

    document.addEventListener('items-changed', schedulePaint);
    document.addEventListener('deal-bar-selected', schedulePaint);
    document.addEventListener('gr:variant:change', schedulePaint);
    document.addEventListener('shopify:section:load', schedulePaint);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();